import NavigationTabs from "../Models/MicroSlide/NavigationTabs";
import { Box } from "@mui/material";

const MicroSlide = () => {
    return (
        <Box sx={{ p: 0 }}>
            <NavigationTabs />
        </Box>
    );
};

export default MicroSlide;
